import React, {createContext, useContext, useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import Box from '@mui/material/Box';

const HeaderSlotContext = createContext({
    rightNode: null, setRightNode: () => {},
    bannerNode: null, setBannerNode: () => {},
    statusReserved: false, setStatusReserved: () => {}
});

export const HeaderSlotProvider = ({children}) => {
    const [rightNode, setRightNode] = useState(null);
    const [bannerNode, setBannerNode] = useState(null);
    const [statusReserved, setStatusReserved] = useState(false);
    return (
        <HeaderSlotContext.Provider value={{rightNode, setRightNode, bannerNode, setBannerNode, statusReserved, setStatusReserved}}>
            {children}
        </HeaderSlotContext.Provider>
    );
};

// Reserve a stable status line in the header so transient content (the autosave
// indicator) can appear/disappear without changing the header height. While
// reserved and empty, the breadcrumb sits vertically centered in the taller
// header; once the indicator shows it fills the reserved space — no page shift.
export const useReserveHeaderStatus = active => {
    const {setStatusReserved} = useContext(HeaderSlotContext);
    useEffect(() => {
        if (!active) return undefined;
        setStatusReserved(true);
        return () => setStatusReserved(false);
    }, [active, setStatusReserved]);
};

export const useHeaderStatusReserved = () => useContext(HeaderSlotContext).statusReserved;

export const HeaderSlotTarget = props => {
    const {setRightNode} = useContext(HeaderSlotContext);
    return <Box ref={setRightNode} {...props} />;
};

export const HeaderBannerSlotTarget = ({style, ...props}) => {
    const {setBannerNode} = useContext(HeaderSlotContext);
    return <div ref={setBannerNode} style={{display: 'contents', ...style}} {...props} />;
};

export const HeaderSlot = ({children}) => {
    const {rightNode} = useContext(HeaderSlotContext);
    if (!rightNode) return null;
    return createPortal(children, rightNode);
};

export const HeaderBannerSlot = ({children}) => {
    const {bannerNode} = useContext(HeaderSlotContext);
    if (!bannerNode) return null;
    return createPortal(children, bannerNode);
};
